import {SET_SUBAPP_ORG_IDS, SET_SUBORGS_ALLOWED} from 'common/types';
export default {
  setSubAppOrgIds: (res) => ({type: SET_SUBAPP_ORG_IDS, payload: res}),
  setSuborgsAllowed: (bool) => ({type: SET_SUBORGS_ALLOWED, payload: bool}),
};
